import { InjectionToken } from '@angular/core';

import { TaskDataMap, TaskResponse, TaskType } from '../models/task.interface';

export interface TaskMapper<T extends TaskType = TaskType> {
  readonly type: T;
  map(r: TaskResponse): TaskDataMap[T];
}

export const TASK_MAPPERS = new InjectionToken<TaskMapper[]>('TASK_MAPPERS');
